export default {
  chart3: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
  },
  chart4: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
  },
  chart5: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
  },
  chart6: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
  },
};
